import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { FeatureFlagService } from './feature-flag.service';

/**
 * Factory that returns a CanMatchFn which blocks the route when the given
 * feature flag is disabled. When blocked, Angular falls through to the next
 * matching route (typically the wildcard → NotFoundComponent).
 *
 * Usage:
 *   canMatch: [authCanMatch, featureFlagCanMatch('BulkUploadMembers')]
 */
export function featureFlagCanMatch(featureName: string): CanMatchFn {
  return () => inject(FeatureFlagService).isEnabled(featureName);
}
